import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React from 'react';
import { useSwipeable } from 'react-swipeable';
import useDevice from 'wfui-digital-core/es/useDevice';
import useSettings from '../../hooks/use-settings';
import swipeHandler from './support/swipe-handler';

var SwipeableContainer = function SwipeableContainer(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var device = useDevice();

  var _useSettings = useSettings(),
      useMobileStickyFooter = _useSettings.useMobileStickyFooter,
      setForceMobileStickyFooter = _useSettings.setForceMobileStickyFooter;

  var swipeHandlers = useSwipeable({
    onSwiped: function onSwiped(event) {
      return swipeHandler({
        event: event,
        setForceMobileStickyFooter: setForceMobileStickyFooter
      });
    }
  });
  var props = Object.assign({}, device.isMobile() && useMobileStickyFooter ? swipeHandlers : {});
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className
  }, props), children);
};

export default SwipeableContainer;